import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import * as R from 'ramda'
import { scroller } from 'react-scroll'
import { MODAL_TYPE } from 'Defaults/modals'
import { urlSearchParamsToObj } from 'Utils/routerUtils'
import { createPhotoPaths } from 'Utils/photoUtils'
import { LISTING_ALERT_TYPE, BUILDING_ALERT_TYPE } from 'Modules/user/alerts/actions'
import BuildingAlertCard from '../BuildingAlertCard'
import ListingAlertCard from '../ListingAlertCard'
import { _AlertList } from './styles'

const AlertList = (
  {
    alerts, alertType, updateAlert,
    deleteAlert, openModal, closeModal, selectedAlertId, leadId, selectedAlert,
    loadAlertListings, alertListings, deletingId, isReComputingTags, location, googleAnalyticsEvent,
  }) => {
  let AlertCard = null
  if(alertType === LISTING_ALERT_TYPE) {
    AlertCard = ListingAlertCard
  } else if(alertType === BUILDING_ALERT_TYPE) {
    AlertCard = BuildingAlertCard
  } else {
    return null
  }

  useEffect(() => {
    // scroll to specific alert if url has hash
    if(location && location.hash) {
      const hash = location.hash.substring(1)

      const elem = document.querySelector(`#alertCard-${hash}`)
      if(elem) {
        scroller.scrollTo(hash, {
          duration: 800,
          delay: 0,
          smooth: 'easeInOutQuart',
          offset: -150, // Scrolls to element + 50 pixels down the page
          // ...
        })
      }
    }
  }, [alerts])

  function onDeleteClick(id, messagesChildren) {
    openModal({
      modalType: MODAL_TYPE.CONFIRM,
      modalData: {
        messagesChildren,
        onConfirm: () => {
          deleteAlert({ id, alertType })
          closeModal()
        },
      },
    })
  }
  function alertUpdated(alert, updatedField) {
    const { name, newValue } = updatedField
    const newAlert = {
      ...alert,
      [name]: newValue,
    }
    const url = alert.url
    const params = url.split('?')
    const paramObj = urlSearchParamsToObj(params[1])
    if(paramObj[name] && R.equals(paramObj[name], newValue)) return null
    switch(name) {
      case 'building_ids':
        paramObj.building_id = [...newValue].join(',')
        break
      case 'cc_list':
        newAlert.cc_list = [...newValue].join(',')
        break
      case 'alert_frequency':
        newAlert.alert_frequency = Number(newValue)
    }
    updateAlert({
      id: alert.id,
      payload: {
        alert_frequency: newAlert.alert_frequency,
        name: newAlert.name,
        type: alertType,
        url: params[0] + '?' + new URLSearchParams(paramObj).toString(),
        cc_list: newAlert.cc_list,
        alertType,
      },
    })
  }

  function onRecipientChange(alert, recipients) {
    alertUpdated(alert, { name: 'cc_list', newValue: recipients })
  }
  function onFrequencyUpdate(alert, frequency) {
    alertUpdated(alert, { name: 'alert_frequency', newValue: frequency.value })
  }
  function getAlertCard(alert, renderSelectedAlert) {
    if(!renderSelectedAlert && selectedAlertId === alert.id) return null
    const listingObj = alertListings[alert.id] || null
    const allImages = []
    let matchedListingCount = 0
    if(listingObj && listingObj.listing) {
      matchedListingCount = listingObj.nbHits
      listingObj.listings.forEach(listing => {
        const {
          photo_base_url: photoBaseUrl, mls_number: mlsNumber, photo_version: photoVersion,
          photo_source: photoSource,
        } = listing

        const firstPhotoObj = createPhotoPaths({
          photoBaseUrl,
          mlsNumber,
          photoIndex: 1,
          photoVersion,
          photoSource,
        })
        allImages.push(firstPhotoObj?.img)
      })
    }

    return (
      <AlertCard
        key={alert.id}
        alertType={alertType}
        id={alert.id}
        isFetching={listingObj && listingObj.isFetching}
        frequency={Number(alert.alert_frequency)}
        ccList={alert.cc_list}
        deletingId={deletingId}
        name={alert.name}
        notifyBy={alert.notify_by}
        searchUrl={alert.search_url}
        url={alert.url}
        buildingIds={alert.building_ids}
        updateAlert={alertUpdated}
        alert={alert}
        filterStrings={alert.filter_strings}
        onRecipientChange={onRecipientChange}
        onFrequencyUpdate={onFrequencyUpdate}
        deleteAlert={onDeleteClick}
        openModal={openModal}
        // listing alert only
        leadId={leadId}
        loadAlertListings={loadAlertListings}
        matchedListingCount={matchedListingCount}
        tags={alert.tags}
        isReComputingTags={isReComputingTags}
        allImages={allImages}
        googleAnalyticsEvent={googleAnalyticsEvent}
      />
    )
  }
  return (
    <_AlertList
      data-test-id="savedListingAlerts"
    >
      {
        selectedAlert && getAlertCard(selectedAlert, true)
      }
      {alerts && alerts.map(alert => getAlertCard(alert))}
    </_AlertList>
  )
}
AlertList.propTypes = {
  alerts: PropTypes.arrayOf(PropTypes.shape({})),
  alertType: PropTypes.string,
  deletingId: PropTypes.string,
  selectedAlertId: PropTypes.string,
  leadId: PropTypes.string,
  updateAlert: PropTypes.func,
  deleteAlert: PropTypes.func,
  loadAlertListings: PropTypes.func,
  openModal: PropTypes.func,
  closeModal: PropTypes.func,
  isReComputingTags: PropTypes.bool,
  alertListings: PropTypes.shape({}),
  selectedAlert: PropTypes.shape({}),
  location: PropTypes.shape({
    hash: PropTypes.string,
  }),
  googleAnalyticsEvent: PropTypes.func,
}
export default AlertList
